export default {
  baseUrlForConfig: process.env.VUE_APP_DASHBOARD,
  baseUrlForAnalyticsService: process.env.VUE_APP_ANALYTICS,
  baseUrlForUserOrg: process.env.VUE_APP_USERORG,
  baseUrlForDiscoveryProject: process.env.VUE_APP_DISCOVERY_PROJECT,
  baseUrlForAnnotations: process.env.VUE_APP_ANNOTATION_SERVICE,
  baseUrlForProjectSearch: process.env.VUE_APP_SEARCH,
  baseUrlForArchiveExport: process.env.VUE_APP_ARCHIVE_EXPORT,
  baseUrlForMailSphere: process.env.VUE_APP_MAILSPHERE,
  baseUrlForAuditLogService: process.env.VUE_APP_AUDIT_LOG,
  baseUrlForPreferencesService: process.env.VUE_APP_PREFERENCES,
  defaultPreferenceId: process.env.VUE_APP_DEFAULT_PREFERENCE_ID,
  callbackrlForSSO: process.env.VUE_APP_REDIRECT_URL_SSO,
  baseUrlForArchiveExplorer: process.env.VUE_APP_ARCHIVE_EXPLORER,
  baseUrlForRestorationService: process.env.VUE_APP_MSO365_RESTORATION_SERVICE,
  baseUrlForNotificationService: process.env.VUE_APP_NOTIFICATION_SERVICE,
  baseUrlForNotificationTemplateService:
    process.env.VUE_APP_NOTIFICATION_SERVICE,
  baseUrlForSyncListenerService: process.env.VUE_APP_SYNC_LISTENER_SERVICE,
  baseUrlForSyncConsumerService: process.env.VUE_APP_SYNC_CONSUMER_SERVICE,
  baseUrlForMailSyncConsumerService: process.env.VUE_APP_MAIL_SYNC_CONSUMER_SERVICE,
  websocketUrl: process.env.VUE_APP_WEBSOCKET_URL,
  baseUrlForMailSync: process.env.VUE_APP_MAIL_SYNC,
  baseUrlForAWSJobStatus: process.env.VUE_APP_AWS_JOB_STATUS,
  rapid7Token: process.env.VUE_APP_RAPID_7_TOKEN,
  baseUrlAlertingService: process.env.VUE_APP_ALERTING_SERVICE,
  baseUrlForBillingService: process.env.VUE_APP_BILLING_SERVICE,
  baseUrlForHelp: process.env.VUE_APP_HELP_SEARCH_API,
  baseUrlForMTAServiceStatus: process.env.VUE_APP_MTA_SERVICE_STATUS,
  baseUrl: process.env.VUE_APP_BASE_URL,
  HelpServiceAuth: 'Basic bXNsaXZlOlhpZnRAMTIz',
  chargifyPublicKey: process.env.VUE_APP_CHJS_PUBLIC_KEY,
  charifyGateway: {
    card: process.env.VUE_APP_CHJS_ST_TOKEN,
    direct_debit: process.env.VUE_APP_CHJS_GC_TOKEN
  },
  chargifyServerHost: process.env.VUE_APP_SERVER_HOST,
  onboardingService: process.env.VUE_APP_ONBOARDING_SERVICE,
  searchService: process.env.VUE_APP_SEARCH,
  contactUsUrl: process.env.VUE_APP_CONTACT_US_URL,
  mailsSyncClientId:process.env.VUE_APP_MAIL_SYNC_CLIENT_ID,
  dataPackHandle: process.env.VUE_APP_DATA_PACK_HANDLE,
  discoveryPackHandle: process.env.VUE_APP_DISCOVERY_PACK_HANDLE,
  baseUrlForOffboardingService:
    process.env.VUE_APP_OFFBOARDING_EXTRACTION_SERVICE,
  baseUrlForApplicationManagerService:
    process.env.VUE_APP_APPLICATION_MANAGER_SERVICE,
  baseUrlForTeamsAdapterService: process.env.VUE_APP_TEAMS_ADAPTER_SERVICE,
  freshworksWidgetId: process.env.VUE_APP_FRESHWORKS_WIDGET_ID,
  baseUrlForDropboxAdapterService: process.env.VUE_APP_DROPBOX_ADAPTER_SERVICE,
};
